module.exports = __webpack_public_path__ + "img/lingdang@2x.fecb571a.png";